import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import Config from "../../Config";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";
import { useDispatch } from "react-redux";
import { Tooltip } from "react-tooltip";
import { Select, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { truncateText, capitalizeFirstLetter } from "../../helpers";
import { FaRegBuilding, FaFemale, FaMale } from "react-icons/fa";
import { BiMaleFemale } from "react-icons/bi";
import { Form, Formik } from "formik";
import NotFoundModel from "../NotFoundModel";
import { FiEdit3, FiPlusCircle } from "react-icons/fi";
import { GrDocumentUser } from "react-icons/gr";
import { MdDeleteOutline, MdElectricBolt } from "react-icons/md";
import { BsBuildings } from "react-icons/bs";

const Table = ({
  apiData,
  setSelectedData,
  selectedData,
  setStep,
  setIsAddProperty,
  activateMutate,
  deactivateMutate,
  setIsDeleteProperty,
  setEditNameModel,
  setLocationModel,
  setLeaseModel,
  mutateFetchLandlordLeaseDetailsFunction,
  setEditFineModel,
  setIsUtilityBills,
  setIsSelectLeaseFlat
}) => {
  const storageKey = `properties_page_index`;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const activeProps = apiData
    .filter((property) => property.status === Config.PROPERTY_STATUS.ACTIVE)
    .map((property) => ({
      id: property.id,
      name: property.name,
      gId: property.gId,
      streetAddress: property.streetAddress,
      occupiedBedCount: property.occupiedBedCount,
      vacantBedCount: property.vacantBedCount,
      status: property.status,
      type: property.type,
      security: property.security,
      tenantPreference: property?.tenantPreference || 1,
    }));

  const [selectedRow, setSelectedRow] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  //const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const CustomSelect = styled(Select)({
    "& .MuiSelect-icon": {
      color: "#f59e0b",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    zIndex: 0,
  });

  const addProperty = (item) => {
    setIsAddProperty(true);
    setSelectedData(item);
    if (item.name &&
      item.ownerName &&
      item.ownerMobile &&
      item.address &&
      !item.agreementPeriod &&
      !item.tenantPreference) {
      setStep(2);
    } else if (item.agreementPeriod &&
      item.tenantPreference &&
      !item.rentalCycle) {
      setStep(3);
    }
    setOpenActionMenu(null);
  };

  const deleteProperty = (item) => {
    setIsDeleteProperty(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const leaseProperty = (item) => {
    setSelectedData(item);

    if (item.type === Config.PROPERTY_TYPE.PG) {
      mutateFetchLandlordLeaseDetailsFunction({ propId: item.id });
      setIsSelectLeaseFlat(false);
    }
    else if (item.type === Config.PROPERTY_TYPE.FLAT) {
      if (item.flats?.length === 1) {
        mutateFetchLandlordLeaseDetailsFunction({ propId: item.id, flatId: item.flats[0].id });
        setIsSelectLeaseFlat(false);
      } else {
        setIsSelectLeaseFlat(true);
      }
    }
    else {
      mutateFetchLandlordLeaseDetailsFunction({ propId: item.id });
      setIsSelectLeaseFlat(false);
    }

    setOpenActionMenu(null);
  };

  const editNameProperty = (item) => {
    setEditNameModel(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const editFine = (item) => {
    setEditFineModel(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const utilityBill = (item) => {
    setIsUtilityBills(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const addLocation = (item) => {
    setLocationModel(true);
    setSelectedData(item);

  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            <MenuItemCustom
              onClick={() => {
                navigate('/property-detail', { state: { propertyDetails: item } });
                setOpenActionMenu(null);
              }}
            >
              <BsBuildings className="text-gray-500 mr-2" />Property Detail
            </MenuItemCustom>
            {item.status !== Config.PROPERTY_STATUS.INACTIVE && (
              <>
                <MenuItemCustom
                  onClick={() => {
                    navigate('/beds-view', { state: { propertyDetails: item, properties: activeProps } });
                    setOpenActionMenu(null);
                  }}
                >
                  <FaRegBuilding className="text-gray-500 mr-2" />Manage Inventory
                </MenuItemCustom>
              </>
            )}

            {item.status === Config.PROPERTY_STATUS.ACTIVE &&
              <>
                {/* <MenuItemCustom
                  sx={{ fontSize: '15px', fontWeight: 400, color: '#6B7280' }}
                  onClick={() => {
                    navigate('/food-menu', { state: { propertyDetails: item } });
                    setOpenActionMenu(null);
                  }}
                >
                  <LiaMoneyBillWaveSolid className="text-gray-500 mr-2" size={20} />Food Menu
                </MenuItemCustom> */}
                {/* <MenuItemCustom
                  title="Extra Charges"
                  onClick={() => {
                    navigate('/property-extra-charges', { state: { propertyDetails: item } });
                    setOpenActionMenu(null);
                  }}
                >
                  <MdAddCard className="text-gray-500 mr-2" />Extra Charges
                </MenuItemCustom> */}
                {/* <MenuItemCustom
                  onClick={() => handleShare(item)}
                >
                  <FiShare2 className="text-gray-500 mr-2" />Share Property
                </MenuItemCustom> */}
                <MenuItemCustom
                  onClick={() => { utilityBill(item) }}
                >
                  <MdElectricBolt className="text-gray-500 mr-2" />Add Utility Charges
                </MenuItemCustom>
                {/* <MenuItemCustom
                  title="Electricity Bill"
                  onClick={() => {
                    navigate('/electricity-bill', { state: { propertyDetails: item } });
                    setOpenActionMenu(null);
                  }}
                >
                  <FaBolt className="text-gray-500 mr-2" />Electricity Bill
                </MenuItemCustom>  */}
              </>
            }
            {item.leaseAdded === false && item.status != Config.PROPERTY_STATUS.INACTIVE &&
              <MenuItemCustom
                sx={{ fontSize: '15px', fontWeight: 400, color: '#6B7280' }}
                onClick={() => {
                  leaseProperty(item);
                  setOpenActionMenu(null);
                }}
              >
                <GrDocumentUser className="text-gray-500 mr-2" />Lease Details
              </MenuItemCustom>}
            <MenuItemCustom
              sx={{ fontSize: '15px', fontWeight: 400, color: '#6B7280' }}
              onClick={() => {
                deleteProperty(item);
                setOpenActionMenu(null);
              }}
            >
              <MdDeleteOutline className="text-gray-500 mr-2" size={20} />Delete
            </MenuItemCustom>
          </MenuOptions>
        )}
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-500" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        address: getAddress(item),
        status: getStatus(item),
        action: ActionBtns(item),
        beds: bedCount(item),
        totalCollection: <Amount>{'₹' + item.totalCollection}</Amount>
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => (
    <UserImageWrapper>
      {/* Preference icon */}
      <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100">
        {item.tenantPreference === 1 ? (
          <FaMale className="text-blue-400" />
        ) : item.tenantPreference === 2 ? (
          <FaFemale className="text-pink-400" />
        ) : (
          <BiMaleFemale className="text-purple-400" />
        )}
      </div>

      <div className="flex flex-col min-w-0">
        <div className="flex items-center gap-2 group cursor-pointer"
          // onClick={() =>
          //   navigate('/inventory', { state: { propertyDetails: item } })
          // }
          onClick={() => {
            navigate('/beds-view', { state: { propertyDetails: item, properties: activeProps } });
          }}
        >
          <span className="font-medium text-gray-700 truncate">
            {capitalizeFirstLetter(truncateText(item.name, 28))}
          </span>

          <button
            onClick={(e) => {
              e.stopPropagation();
              editNameProperty(item);
            }}
            className="opacity-0 group-hover:opacity-100 transition"
            title="Edit name"
          >
            <FiEdit3 size={14} className="text-gray-400 hover:text-primary-color" />
          </button>
        </div>

        <span className="text-xs text-gray-400">#{item?.gId || "NA"}</span>
      </div>
    </UserImageWrapper>
  );

  const getAddress = (item) => (
    <div className="text-sm text-gray-600 space-y-1">
      <div className="flex items-center gap-2">
        <span className="truncate max-w-[160px]">
          {capitalizeFirstLetter(truncateText(item.streetAddress, 22))}
        </span>

        <button
          onClick={() => addLocation(item)}
          className="text-gray-400 hover:text-primary-color"
          title={item.latitude ? "Edit Co-ordinates" : "Add Co-ordinates"}
        >
          {item.latitude ? <FiEdit3 size={14} /> : <FiPlusCircle size={14} />}
        </button>
      </div>

      {item.latitude && item.longitude && (
        <span className="text-xs text-gray-400">
          📍 {item.latitude}, {item.longitude}
        </span>
      )}
    </div>
  );

  const bedCount = (item) => (
    <button
      onClick={() => navigate("/inventory", { state: { propertyDetails: item } })}
      className="bg-neutral-100 hover:bg-neutral-200 text-gray-700 px-3 py-1 rounded-md text-sm transition"
    >
      {item.occupiedBedCount} / {item.vacantBedCount}
      <span className="ml-1 text-xs text-gray-400">(Occ/Vac)</span>
    </button>
  );


  const getStatus = (item) => {
    if (item.status === 1) {
      return <Pending onClick={() => addProperty(item)}>Continue Adding Property</Pending>;
    }
    // else if (item.status === 2) {
    //     return <Completed
    //         // onClick={() => {
    //         //     dispatch(Select_Property(item));
    //         //     navigate("/property/rooms");
    //         // }}
    //         onClick={() => {
    //             navigate('/property/rooms', { state: { propertyDetails: item } });

    //         }}
    //     >Add Room</Completed>;

    // }
    else if (item.status === 2) {
      if (item.roomCount === 0) {
        return (
          <Completed
            onClick={() => {
              navigate("/property/rooms", { state: { propertyDetails: item } });
            }}
          >
            Add Room
          </Completed>
        );
      } else if (item.bedCount === 0) {
        return (
          <Completed
            onClick={() => {
              // Navigate to add bed page or show add bed modal
              navigate("/property/rooms", { state: { propertyDetails: item } });
            }}
          >
            Add Bed
          </Completed>
        );
      } else {
        return (
          <Formik
            initialValues={{ status: "" }}
            onSubmit={() => { }}
          >
            {({ setFieldValue, values }) => (
              <Form>
                <CustomSelect
                  value={values.status}
                  displayEmpty
                  onChange={(e) => {
                    const selectedStatus = e.target.value;
                    setFieldValue("status", selectedStatus);

                    const payload = { propId: item.id };

                    if (selectedStatus === "active") {
                      activateMutate(payload);
                    }
                  }}
                  sx={{
                    "& .MuiSelect-icon": {
                      color: "#ef4444",
                    },
                    "& .MuiOutlinedInput-input": {
                      zIndex: 0,
                    },
                  }}
                  variant="outlined"
                  size="small"
                  className="bg-rose-50 !rounded-lg !text-rose-500 !font-normal !text-sm !h-7"
                >
                  <MenuItem value="" disabled>
                    Completed
                  </MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                </CustomSelect>
              </Form>
            )}
          </Formik>
        );
      }
    }
    else if (item.status === Config.PROPERTY_STATUS.ACTIVE) {
      return <Formik
        initialValues={{ status: "" }}
        onSubmit={() => { }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <CustomSelect
              value={values.status}
              displayEmpty
              onChange={(e) => {
                const selectedStatus = e.target.value;
                setFieldValue("status", selectedStatus);

                const payload = { propId: item.id };

                if (selectedStatus === "inactive") {
                  deactivateMutate(payload);
                }
              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#22c55e",
                },
                "& .MuiOutlinedInput-input": {
                  zIndex: 0,
                },
              }}
              variant="outlined"
              size="small"
              className="bg-green-50 !rounded-lg !text-green-500 !font-normal !text-sm !h-7"
            >
              <MenuItem value="" disabled >
                Active
              </MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </CustomSelect>
          </Form>
        )}
      </Formik>;
    } else if (item.status === 4) {
      return <Formik
        initialValues={{ status: "" }}
        onSubmit={() => { }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <CustomSelect
              value={values.status}
              displayEmpty
              onChange={(e) => {
                const selectedStatus = e.target.value;
                setFieldValue("status", selectedStatus);

                const payload = { propId: item.id };

                if (selectedStatus === "active") {
                  activateMutate(payload);
                }
              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#ef4444",
                },
              }}
              variant="outlined"
              size="small"
              className="bg-red-50 !rounded-lg !text-red-500 !font-normal !text-sm !h-7"
            >
              <MenuItem value="" disabled>
                Inactive
              </MenuItem>
              <MenuItem value="active">Active</MenuItem>
            </CustomSelect>
          </Form>
        )}
      </Formik>;
    } else {
      return "Invalid Status";
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Property Details",
          accessor: "name",
        },
        {
          Header: "Status",
          accessor: "status",
        },
      ];
    }
    return [
      {
        Header: "Property",
        accessor: "name",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Beds",
        accessor: "beds",
      },
      // {
      //     Header: "Collection",
      //     accessor: "totalCollection",
      // },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  useEffect(() => {
    //setCurrentPage(pageIndex); // Update current page on state change
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Address:</strong> {data[rowIndex].address}
                        </li>
                        <li>
                          <strong>Occupied/Vacant Beds:</strong> {data[rowIndex].beds}
                        </li>
                        <li>
                          <strong>Collection:</strong> {data[rowIndex].totalCollection}
                        </li>
                        <li>
                          <strong>Action</strong>{" "}
                          {data[rowIndex].action}
                        </li>


                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {apiData?.length === 0 && <NotFoundModel />}
    </>
  );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
//const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuOptions = tw.div`
  absolute bottom-10 right-0
  py-2 w-max
  bg-white z-50
  rounded-xl
  shadow-xl
  border border-gray-200
  flex flex-col
`;
const MenuItemCustom = tw.div`flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50`;

const Active = tw.div`bg-green-50 text-green-500 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Pending = tw.div`cursor-pointer bg-blue-50 text-blue-500 text-xs border-blue-300 border w-40  h-7 flex items-center justify-center rounded-lg cursor-pointer`;
const Completed = tw.div`bg-lime-50 text-lime-500 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded-lg cursor-pointer`;
const Inactive = tw.div`bg-red-50 text-red-500 text-xs border-red-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const PG = tw.div``;
const Flat = tw.div``;
const Amount = tw.p`text-gray-600 text-sm flex`
export default Table;
